// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/dotsloader/index.scss
// module id = 2512
// module chunks = 13